import React, { Component } from 'react';
import { register } from '../../ducks/auth';
import { getProfile } from '../../ducks/users';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';
import { Redirect } from 'react-router-dom';
import debounce from 'lodash/debounce'
import map from 'lodash/map'
import { AwesomeButtonProgress } from "react-awesome-button"
import "react-awesome-button/dist/styles.css";
import InputField from '../../components/atom/InputField';
import Gamepad from '../../assets/Gamepad';
import setPageTitle from '../../components/atom/PageTitle'


const mapStateToProps = (store) => {
  return {
    me: !!store.users.me
  }
}

class Signup extends Component {

  constructor(props) {
    super(props);

    this.events = {
      handleButton: debounce(this._handleButton.bind(this), 300),
      handleChange: this._handleChange.bind(this),
      handleSubmit: this._handleSubmit.bind(this),
    }

    this.methods = {
      checkLogin: this._checkLogin.bind(this),
    }

    this.state = {
      nickname: '',
      email: '',
      password: '',
      password2: '',
      captchaWarning: false,
      redirect: false,
      emptyPassword: false,
      missmatchPassword: false,
      apiPasswordError: false,
      usernameError: false,
      emailError: false,
      fakePress: false,
    };

    this._reCaptchaRef = React.createRef();
  }

  componentDidMount() {
    this.methods.checkLogin(this.props)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.methods.checkLogin(nextProps)
  }

  _checkLogin(props) {
    const { me } = props
    if (me) return this.setState({ redirect: true })
  }

  _handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  _handleSubmit(event) {
    event.preventDefault();
    this.setState({ fakePress: !this.state.fakePress }, () => {
      this.setState({ fakePress: !this.state.fakePress})
    })
  }

  async _handleButton(element, next) {
    const { dispatch } = this.props
    let error
    
    const reCaptchaToken = await this._reCaptchaRef.current.executeAsync()

    this.setState({
      captchaWarning: false,
      redirect: false,
      emptyPassword: false,
      missmatchPassword: false,
      apiPasswordError: false,
      usernameError: false,
      emailError: false,
      emailDuplicate: false,
    })

    if (this.state.password !== this.state.password2) {
      this.setState({ missmatchPassword: true })
      error = true
    }

    if (!this.state.password && !this.state.password2) {
      this.setState({ emptyPassword: true })
      error = true
    }

    if (!reCaptchaToken) {
      this.setState({ captchaWarning: true })
      error = true
    }

    if (error) {
      return next(false, 'Fel :(')
    }

    dispatch(register(this.state.nickname, this.state.email, this.state.password, reCaptchaToken))
      .then(res => {
        dispatch(getProfile())
      }).catch(err => {
        map(err, (e) => {
          if (e.field === 'email') {
            this.setState({ emailError: true })
            map(e.messages, (m) => {
              if (/already exists/.test(m)) this.setState({ emailDuplicate: true })
            })
          }
          if (e.field === 'password') {
            this.setState({ apiPasswordError: true })
          }
          if (e.field === 'name') {
            this.setState({ usernameError: true })
          }
        })
        return next()
      })
  }

  render() {
    const { statusCode } = this.props
    const { captchaWarning, redirect, missmatchPassword, emptyPassword, apiPasswordError, emailError, usernameError, emailDuplicate } = this.state

    setPageTitle('Registrera')

    const passwordError = missmatchPassword || emptyPassword || apiPasswordError

    if (redirect) return <Redirect to='/' />

    let errorMsg = { empty: '', missmatch: '', duplicate: '' };
    if (emptyPassword) {
      errorMsg.empty = 'Lösenord saknas';
    }
    if (missmatchPassword) {
      errorMsg.missmatch = 'Lösenorden matchar inte';
    }
    if (emailDuplicate) {
      errorMsg.duplicate = 'Mailen är redan registrerad';
    }
    if (emailError && !emailDuplicate) {
      errorMsg.duplicate = 'Kolla att emailen är korrekt';
    }

    return (
      <div className="Signup-page">
        <div className="Signup-header">
          <h1>Registrera</h1>
          Det här formuläret är inte helt klart och ger ingen feedback,
          användarnamn måste vara unikt, giltig email och lösenord på minst sex
          tecken krävs.
        </div>
        <form onSubmit={this.events.handleSubmit}>
          <InputField
            label="ANVÄNDARNAMN"
            errorMsg=""
            type="text"
            name="nickname"
            value={this.state.nickname}
            onChange={this.events.handleChange}
          />
          <InputField
            label="EMAIL"
            errorMsg={errorMsg.duplicate}
            type="email"
            name="email"
            value={this.state.email}
            onChange={this.events.handleChange}
          />
          <InputField
            label="LÖSENORD"
            errorMsg={errorMsg.empty}
            type="password"
            name="password"
            value={this.state.password}
            onChange={this.events.handleChange}
          />
          <InputField
            label="LÖSENORD IGEN"
            errorMsg={errorMsg.missmatch}
            type="password" 
            name="password2"
            value={this.state.password2}
            onChange={this.events.handleChange}
          />
          <ReCAPTCHA
            ref={this._reCaptchaRef}
            size="invisible"
            sitekey="6LeR_ycaAAAAANXg7ff9sz2upRz6R93k8oK_O0NC"
          />
          <div className="Signup-column">
            <AwesomeButtonProgress
              fakePress={this.state.fakePress}
              type="primary"
              loadingLabel="Loading"
              onPress={(element, next) => this.events.handleButton(element, next)}
            >
              <Gamepad
                style={{ position: 'relative', height: '17px', top: '4px', marginRight: '3px' }}
                color="white"
              />{' '}
              Registrera
            </AwesomeButtonProgress>
            <p>
              Genom att registrera dig godkänner du vår{' '}
              <Link to="/sekretess" target="_blank">sekretesspolicy</Link>.
            </p>
          </div>
        </form>

        {statusCode && <p style={{ color: 'green' }}>Kontot är skapat.</p>}
        {statusCode === 400 && <p style={{ color: '#e43731' }}>Något gick fel.</p>}

      </div>
    );
  }
}

export default connect(mapStateToProps)(Signup);